import axios from "axios";
import { GET_IMAGE, GET_PDF } from "../../types";

// Action creator for posting user info
export const getImageInfo = (qValue, requestOptions) => {
  return async (dispatch) => {
    try {
      // Make the Axios POST request to your backend
      const response = await axios.get(
        `https://one.lifebank.ng/api/v1/marketing/guide/tool/${qValue}`,
        requestOptions
      );
      // const response = await axios.get(
      //   `https://one.lifebanktest.com/v1/marketing/guide/tool/${qValue}`,
      //   requestOptions
      // );

      // Dispatch the request action
      dispatch({ type: GET_IMAGE, payload: response.data });

      // Return the response data if needed
      return response.data;
    } catch (error) {
      // Dispatch the failure action if there's an error
      dispatch({ type: GET_IMAGE, error });

      // You can handle errors or dispatch additional actions here
    }
  };
};
